import createModel from 'utils/model'
import {
    todayCustomerStat,
    todayChannelRank,
    customerStat,
    customerChannels,
    lostCustomers,
} from 'crm/services/home'
import {parseCustomerChannels} from 'crm/utils/customer'

function parseTodayChannelRank(data) {
    if (Array.isArray(data)) {
        return data.map((item) => ({
            channel: item.channel?.name,
            count: item.inc_count,
        }))
    }
    return []
}

export default createModel({
    namespace: 'crm_home',

    state: {
        summary: {},
        todayChannelRankOriginData: [],
        newCustomersData: [],
        totalCustomersData: [],
        customerChannelsOriginData: [],
        lostCustomers: [],
    },

    effects: {
        *lostCustomers({payload}, {call, put}) {
            const res = yield call(lostCustomers, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    lostCustomers: res?.data,
                },
            })
        },
        *todayCustomerStat(_, {call, put}) {
            const res = yield call(todayCustomerStat)
            const data = (res && res.data) || {}
            yield put({
                type: 'setProperty',
                payload: {
                    summary: data,
                },
            })
        },
        *todayChannelRank({payload}, {call, put}) {
            const res = yield call(todayChannelRank, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    todayChannelRankOriginData: parseTodayChannelRank(res?.data),
                },
            })
        },
        *customerStat({payload}, {call, put}) {
            const res = yield call(customerStat, payload)
            const data = (res && res.data) || []

            const incData = []
            const totalData = []

            data.forEach((item) => {
                const date = item.st_date.substring(5)
                incData.push({
                    name: date,
                    value: item.inc_count,
                })
                totalData.push({
                    name: date,
                    value: item.total_count,
                })
            })

            yield put({
                type: 'setProperty',
                payload: {
                    newCustomersData: incData,
                    totalCustomersData: totalData,
                },
            })
        },
        *customerChannels(_, {call, put}) {
            const res = yield call(customerChannels)
            const parsedChannels = parseCustomerChannels(res?.data)
            yield put({
                type: 'setProperty',
                payload: {
                    customerChannelsOriginData: parsedChannels,
                },
            })
        },
    },

    reducers: {},
})
